
import { Routes } from '@angular/router';
import { TabsPage } from './tabs/tabs.page';

export const routes: Routes = [

  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'optLogin',
    loadComponent: () => import('./optLogin/optLogin.page').then(m => m.OptLoginPage)
  },
  {
    path: 'signup',
    loadComponent: () => import('./signup/signup.page').then(m => m.SignupPage)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password.page').then(m => m.ForgotPasswordPage)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./reset-password/reset-password.page').then(m => m.ResetPasswordPage)
  },

  {
    path: 'welcome',
    loadComponent: () =>
      import('./welcome/welcome.page').then(m => m.WelcomePage)
  },
  {
    path: 'intro',
    loadComponent: () => import('./intro/intro.page').then(m => m.IntroPage)
  },
  {
    path: 'how-it-works',
    loadComponent: () => import('./how-it-works-animated/how-it-works-animated.page').then(m => m.HowItWorksAnimatedPage)
  },
  {
    path: 'how-it-works-simple',
    loadComponent: () => import('./how-it-works-simple/how-it-works-simple.page').then(m => m.HowItWorksSimplePage)
  },
  {
    path: 'tabs',
    component: TabsPage,
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.page').then(m => m.DashboardPage)
      },
      {
        path: 'login',
        loadComponent: () => import('./login/login.page').then(m => m.LoginPage)
      },
      {
        path: 'createHobby',
        loadComponent: () => import('./createHobby/createHobby.page').then(m => m.CreateHobbyPage)
      },



      {
        path: 'profile',
        loadComponent: () =>
          import('./profile/profile.page').then(m => m.ProfilePage)
      },
      {
        path: 'matches',
        loadComponent: () =>
          import('./matches/matches.page').then(m => m.MatchesPage)
      },
      {
        path: 'myHobbies',
        loadComponent: () =>
          import('./myHobbies/myHobbies.page').then(m => m.MyHobbiesPage)
      },
      {
        path: 'hobbies',
        loadComponent: () => import('./hobbies/hobbies.page').then(m => m.HobbiesPage)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },
  // Under construction page - commented out (app now open to all users!)
  // {
  //   path: 'under-construction',
  //   loadComponent: () => import('./under-construction/under-construction.page').then(m => m.UnderConstructionPage)
  // },
  {
    path: '',
    redirectTo: '/welcome',
    pathMatch: 'full'
  }
];
